import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { CustomTable } from '../../../components/atoms';
import { getAdminOrders } from '../../../network/services/admin/order';
import { completedOrderColumn } from '../data';

function CompletedOrdersTable() {
  const [page, setPage] = useState(1);
  const pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE ? parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE) : 10;
  const { data, isFetchedAfterMount, isLoading } = useQuery(
    ['admin_orders', { page: page - 1, size: pageSize, type: 'COMPLETED' }],
    getAdminOrders,
    {
      staleTime: Infinity
    }
  );
  const orders = data?.data || [];

  // const completedOrders = orders.filter((order: any) => order.status.toLowerCase() === 'completed');

  return (
    <CustomTable
      isLoading={isLoading}
      columns={completedOrderColumn}
      data={orders}
      totalItems={data?.totalElements ?? 0}
      totalPages={data?.totalPages ?? 0}
      currentPage={page}
      setCurrentPage={setPage}
    />
  );
}

export default CompletedOrdersTable;
